<template>
  <div id="data-view">
    <dv-full-screen-container>
      <div class="main-header">
        <div class="mh-left">{{ curTime }}</div>
        <div class="mh-middle">湖南省重点民生实事家庭教育指导服务“向阳花”行动工作进展</div>
        <div class="mh-right">
技术支持:凤网传媒\今日女报
        </div>
      </div>

      <dv-border-box-1 class="main-container">
        <div class="left-chart-container">
        <dv-border-box-7 class="left-chart-container1">
          <Layout-left />
          <Layout-left-2 v-on:click-city="onCity" />
        </dv-border-box-7>
        <dv-border-box-7 class="left-chart-container2">
          <Layout-left-3 />
        </dv-border-box-7>
        </div>

        <div class="right-main-container">
          <div class="rmc-top-container">
            <div class="rmctc-left-container">

                <dv-border-box-7 class="center-top">
                <Layout-Center-0 />
                </dv-border-box-7>

                <dv-border-box-7 class="center-map">
                <Layout-Center-1-C v-on:click-city="onCity" />
                </dv-border-box-7>

            </div>

            <div class="rmctc-right-container">
              <dv-border-box-7 class="rmctc-chart-1">
                <Layout-Right />
              </dv-border-box-7>
              <dv-border-box-7 class="rmctc-chart-2">
                <Layout-Right-2 />
              </dv-border-box-7>
            </div>
          </div>

          <dv-border-box-7 class="rmc-bottom-container">

            <Layout-Bottom :city="city"/>

          </dv-border-box-7>
        </div>
      </dv-border-box-1>

    </dv-full-screen-container>
  </div>
</template>

<script>
import LayoutLeft from './LayoutLeft';
import LayoutLeft2 from './LayoutLeft2';
import LayoutLeft3 from './LayoutLeft3';

// import LayoutCenter1 from './LayoutCenter1'
// import LayoutCenter1B from './LayoutCenter1B'
import LayoutCenter1C from './LayoutCenter1C'
import LayoutCenter0 from './LayoutCenter0'

import LayoutBottom from './LayoutBottom';
import LayoutRight from './LayoutRight';
import LayoutRight2 from './LayoutRight2';

// import BottomCharts from './BottomCharts'

import { mapState,  } from "vuex";
// import axios from 'axios';

export default {
  name: 'DataView',
  components: {
    LayoutLeft,
    LayoutLeft2,
    LayoutLeft3,
    LayoutCenter0,
    LayoutCenter1C,
    // LayoutCenter1B,
    LayoutBottom,
    LayoutRight,
    LayoutRight2,
  },
  data () {
    return {
        // city: '430100000000',
        alldata: {},
        dateTime: new Date(),
        curTime: ''
    }
  },
  mounted() {
    this.loadList();
  },
  created () {
    this.updateDateTime();
    this.timer = setInterval(() => {
        this.updateDateTime();
    }, 1000);
  },
  computed: {
    ...mapState(['city'])
  },
  methods: {
      updateDateTime() {
          // 获取当前日期时间  
          const now = new Date();
          // 格式化日期时间为“YYYY年MM月DD日 HH:mm:ss”  
          this.curTime = `${now.getFullYear()}年${String(now.getMonth() + 1).padStart(2, '0')}月${now.getDate().toString().padStart(2, '0')}日 ${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
      },  

      loadList() {
      },
    onCity: function (params) {
        // console.log(params)
        const city = params.data ? params.data.city : params.city
        this.$store.dispatch('byCity', city)
        // this.city = params.data.city

    },
  },

}
</script>

<style lang="less">
#data-view {
    width: 100%;
    height: 100%;
    background-color: #030409;
    color: #fff;

    #dv-full-screen-container {
        background-image: url('./img/bg.png');
        background-size: 100% 100%;
        box-shadow: 0 0 3px blue;
        display: flex;
        flex-direction: column;
    }

    .main-header {
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        .mh-left {
            font-size: 20px;
            color: rgb(1, 134, 187);    a:visited {
        color: rgb(1,134,187);
      }
    }

    .mh-middle {
      font-size: 30px;
    }

    .mh-left, .mh-right {
      width: 450px;
    }
  }

  .main-container {
    height: calc(~"100% - 80px");

    .border-box-content {
      padding: 20px;
      box-sizing: border-box;
      display: flex;
    }
  }

  .left-chart-container {
    width: 22%;
    // padding: 10px;
    box-sizing: border-box;

    .border-box-content {
      flex-direction: column;
    }
    .left-chart-container1 {
        height: 80%;
        margin-bottom: 10px;
    }
    .left-chart-container2 {
        height: 18.5%;
        // margin-bottom: 15px;
    }
  }

  .right-main-container {
    width: 78%;
    padding-left: 5px;
    box-sizing: border-box;
  }

  .rmc-top-container {
    height: 65%;
    display: flex;
  }

  .rmctc-left-container {
    width: 65%;
    margin-right: 5px;

    .border-box-content {
      flex-direction: column;
    }
    .center-top {
        height: 12%;
        margin-bottom: 10px;
    }
    .center-map {
        height: 85%;
        margin-bottom: 10px;
    }
  }

  .rmctc-right-container {
    width: 35%;

    .border-box-content {
      flex-direction: column;
    }

    .rmctc-chart-1 {
        height: 60%;
        margin-bottom: 10px;
    }

    .rmctc-chart-2 {
        height: 37%;
    }
  }

  .rmc-bottom-container {
    height: 35%;
  }
}
</style>
